import { render, staticRenderFns } from "./CategoryTree.vue?vue&type=template&id=55844231&scoped=true"
import script from "./CategoryTree.vue?vue&type=script&lang=js"
export * from "./CategoryTree.vue?vue&type=script&lang=js"
import style0 from "./CategoryTree.vue?vue&type=style&index=0&id=55844231&prod&lang=scss&scoped=true"


/* normalize component */
import normalizer from "!../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "55844231",
  null
  
)

export default component.exports